import React from "react";
import { MailOutlined, CopyOutlined } from "@ant-design/icons";

import { DeliveryChoiceModal } from "./DeliveryChoiceModal";

// Admin-driven password reset — entry modal. Shared by two entry points:
// - Toolbar flow (apps/admin, no user table): no targetEmail — the admin
//   types the target email here.
// - Per-row flow (apps/web User Management): the row identifies the target,
//   so targetEmail is passed in and shown as static text (no input).
// Either way the admin then picks how the one-time temp password is delivered.
// A thin wrapper over the shared DeliveryChoiceModal (also used by Send New
// Invitation); the reset-specific title/description/labels live here.
export const ResetPasswordChoiceModal = ({
  open,
  isResetting,
  onConfirm,
  onCancel,
  targetEmail = null,
}) => (
  <DeliveryChoiceModal
    open={open}
    isSubmitting={isResetting}
    onConfirm={onConfirm}
    onCancel={onCancel}
    targetEmail={targetEmail}
    title="Reset password"
    description={
      <>
        A one-time temporary password will be generated. Choose{" "}
        <strong>Copy</strong> to retrieve it and share it via a secure channel,
        or <strong>Email</strong> to send it to the user. They will be required
        to set a new password on their next login.
      </>
    }
    options={[
      { key: "copy", label: "Copy temp password", icon: <CopyOutlined /> },
      {
        key: "email",
        label: "Email temp password",
        icon: <MailOutlined />,
        primary: true,
      },
    ]}
  />
);
